<script>
export default {
    name: 'IconProgression',
}
</script>
<template>
    <svg class="base-icon icon-progression" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64"><g clip-path="url(#a)"><path fill="currentColor"  fill-rule="evenodd" d="M0 58.667h64V64H0v-5.333Zm10.667-16h8v10.666h-8V42.667ZM28 32h8v21.333h-8V32Zm25.333-10.667v32h-8v-32h8Zm4-21.333v16.667h-4.068V7.68L39.333 21.333 28.667 10.667 6.667 32l-3.334-3.333L28.667 4l10.666 10.667 10.68-10.208H40.95V0h16.384Z" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h64v64H0z"/></clipPath></defs></svg>
</template>
